<template>
    <div class="container" style="margin-top: 10px;">
        <h2>Reservaciones</h2>
        <vue-good-table :columns="columns" :rows="reservaciones" :search-options="{ enabled: true }"
            :pagination-options="{
                enabled: true,
                perPage: 5,
                perPageDropdown: [5, 10, 20],
                nextLabel: 'Siguiente',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Filas por página',
                ofLabel: 'de',
                allLabel: 'Todo'
            }">
            <template #table-row="props">
                <span v-if="props.column.field === 'acciones'">
                    <div class="d-grid gap-2">
                        <button class="btn btn-primary text-light" @click="verReserva(props.row.id)"
                            type="button">Borrar <i class="fa-solid fa-trash"></i></button>

                    </div>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
import axios from "axios"
import { VueGoodTable } from "vue-good-table-next"
import "vue-good-table-next/dist/vue-good-table-next.css"
import Swal from "sweetalert2";
export default {
    name: "ReservationsDash",
    components: { VueGoodTable },
    data() {
        return {
            reservaciones: [], // inicializamos vacío
            columns: [
                { label: "ID", field: "id" },
                { label: "Título", field: "title" },
                { label: "Fecha", field: "date" },
                { label: "Nombre", field: "nameUser" },
                { label: "Apellido", field: "apellidoUser" },
                { label: "Experiencia", field: "experiencia" },
                { label: "Horario", field: "horario" },
                { label: "Acciones", field: "acciones" }
            ]
        }
    },
    methods: {
        async getReservaciones() {
            try {
                const response = await axios.get("https://beauvoyage.net/api/showR")
                this.reservaciones = response.data
            } catch (error) {
                console.error("Error al traer las reservaciones:", error)
            }
        },
        verReserva(id) {
            console.log("ID de la fila:", id)
            const token = localStorage.getItem("token")
            try {
                axios.delete("https://beauvoyage.net/api/deleteReservation", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: { id: id }

                }).then(response => {
                    console.log("Respuesta del servidor:", response.data);
                    Swal.fire({
                        icon: 'success',
                        title: 'Reservación eliminada',
                        text: 'La reservación ha sido eliminada exitosamente.',
                        confirmButtonText: 'Aceptar'
                    });
                    this.getReservaciones(); // Actualiza la lista después de borrar
                })
            } catch (error) {
                console.error("Error al borrar la reservación:", error);
            }
        }
    },
    mounted() {
        this.getReservaciones()
    }
}
</script>
